import dayjs from 'dayjs'
import { isNumber } from '../assertion/number'

export type UnitFormatCallback<T> = (value: T) => string

export interface UnitFormat {
  percentage: UnitFormatCallback<number>
  number: UnitFormatCallback<number>
  string: UnitFormatCallback<string>
  date: UnitFormatCallback<string>
  boolean: UnitFormatCallback<boolean>
  function: UnitFormatCallback<() => string>
}

export const unitFormat: UnitFormat = {
  percentage: num =>
    new Intl.NumberFormat('default', {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(num / 100),
  number: String,
  string: String,
  date: date => dayjs(isNumber(date) ? date * 1000 : date).format('D MMM YYYY'),
  boolean: condition => (condition ? 'Yes' : 'No'),
  function: callback => callback()
}

export type Unit = keyof UnitFormat
